"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebformSection = void 0;
const react_1 = __importDefault(require("react"));
const WebformFieldRouter_1 = require("./WebformFieldRouter");
/**
 * Renders a generic section's field grid.
 * The section card wrapper (header, icon) is handled by WebformRenderer.
 */
const WebformSection = ({ section, data, errors, onChange, disabled, lookups, }) => {
    if (!section.fields || section.fields.length === 0)
        return null;
    return (react_1.default.createElement("div", { className: "form-row" }, section.fields.map((field) => (react_1.default.createElement("div", { key: field.key },
        react_1.default.createElement(WebformFieldRouter_1.WebformFieldRouter, { field: field, value: data[field.key], onChange: onChange, error: errors[field.key], disabled: disabled, lookups: lookups }))))));
};
exports.WebformSection = WebformSection;
